<template>
  <img class="w-24 h-24 mt-8 icon inline-block mb-1" :src="src" :alt="alt" />
</template>

<script>
  export default {
    props: ['icon'],
    computed: {
      src() {
        return this.icon && this.icon.image
          ? this.icon.image.fields.file.url
          : '';
      },
      alt() {
        return this.icon && this.icon.alt ? this.icon.alt : 'icon';
      },
    },
  };
</script>
